export const siteMeta = {
  name: "黑料91",
  issue: "第 08 期",
  date: "2026 年 9 月 10 日",
  tagline: "想挖多深都有料",
};

export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "深扒精选", href: "#deep-dive" },
  { label: "合集索引", href: "#collections" },
  { label: "线索档案", href: "#archive" },
  { label: "时间线", href: "#timeline" },
  { label: "热度榜", href: "#ranking" },
];

export const tickerItems = [
  "《长夜未明》补拍通告流出，第三集叙事线整体后移",
  "星芒音乐版权清单更新，两首合作曲署名顺序被调换",
  "砚山影业招商页概念海报换人，同款物料停留 41 天后下架",
  "综艺《同框夜话》成片少 23 分钟，被剪片段指向同一段关系",
  "品牌方季度排他条款复核，两份代言时间出现 7 个月重叠",
  "深扒组本期整理公开记录 128 条，关联人物 26 人",
];

export const coverStory = {
  kicker: "封面故事 · 深扒",
  title: "同框三次，沉默两年：《长夜未明》换角前后的关系网",
  standfirst:
    "从开机通告到补拍档期，从平台招商页到品牌海报，我们把能查到的公开记录按时间排开。谁先松口、谁一直没说话，谁在两个场合给出过互相矛盾的表述——线索会自己说话。",
  byline: "黑料91 · 深扒组",
  readTime: "14 分钟深读",
  updated: "更新于 2026.09.10 09:20",
  image:
    "https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20photograph%20of%20an%20empty%20modern%20film%20studio%20set%20with%20a%20single%20director%20chair%20and%20dramatic%20side%20lighting%2C%20muted%20warm%20cream%20and%20deep%20crimson%20tones%2C%20soft%20film%20grain%2C%20clean%20minimal%20composition%2C%20professional%20editorial%20photography%2C%20high%20detail&width=1200&height=840&seq=cover-story-studio-01&orientation=landscape",
  caption: "《长夜未明》主场景棚已于 2025 年拆除，图为同期留档的置景示意。",
  leads: [
    "开机通告上的主演名单，与平台招商页的最终版本并不一致。",
    "三次补拍档期，全部绕开了同一个日期段。",
    "音乐合作曲的署名顺序，在半年内被修改过两次。",
  ],
  stats: [
    { label: "已整理公开线索", value: "128 条" },
    { label: "关联人物", value: "26 人" },
    { label: "时间跨度", value: "22 个月" },
  ],
};

export const deepDives = [
  {
    index: "01",
    tag: "合约",
    title: "代言重叠的七个月：一份品牌排他条款是怎么被绕开的",
    excerpt:
      "两份代言合同都写着「同类竞品排他」，但生效区间却多出七个月重叠。把签约日、官宣日与物料上线日分开看，答案就浮出来了。",
    meta: "合约档案 · 9 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Flat%20lay%20editorial%20photo%20of%20a%20stack%20of%20signed%20contract%20papers%20and%20a%20fountain%20pen%20on%20a%20warm%20oak%20desk%2C%20soft%20natural%20window%20light%2C%20muted%20cream%20and%20amber%20tones%2C%20clean%20minimal%20background%2C%20professional%20business%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=deepdive-contract-02&orientation=landscape",
  },
  {
    index: "02",
    tag: "署名",
    title: "两首歌、三个版本：音乐合作里被反复修改的署名顺序",
    excerpt:
      "同一首合作曲，在三个平台上出现过三种署名。比对上架时间戳与版权清单版本号，能看到一次并不体面的排序调整。",
    meta: "音乐版权 · 11 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20editorial%20photograph%20of%20an%20analog%20music%20studio%20mixing%20console%20with%20warm%20amber%20indicator%20lights%2C%20dark%20wood%20and%20cream%20panel%20tones%2C%20shallow%20depth%20of%20field%2C%20moody%20but%20clean%20composition%2C%20professional%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=deepdive-studio-03&orientation=landscape",
  },
  {
    index: "03",
    tag: "剪辑",
    title: "综艺成片少了 23 分钟：被剪掉的片段为什么都指向同一段关系",
    excerpt:
      "六期正片里，被删除的片段时长各不相同，但机位与走位高度一致。把分镜表叠在一起，删减就不再是随机结果。",
    meta: "节目观察 · 8 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20video%20editing%20suite%20at%20night%20with%20multiple%20monitors%20showing%20timelines%2C%20warm%20desk%20lamp%20glow%2C%20muted%20grey%20and%20amber%20palette%2C%20no%20people%2C%20clean%20organized%20desk%2C%20professional%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=deepdive-editing-04&orientation=landscape",
  },
];

export const collections = [
  {
    index: "Ⅰ",
    name: "换角风波全记录",
    count: "12 篇",
    desc: "从通告、招商页到补拍档期，一次完整留档。",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20editorial%20photograph%20of%20archive%20folders%20on%20a%20shelf%20in%20warm%20cream%20and%20red%20tones%2C%20soft%20light%2C%20organized%20clean%20composition%2C%20professional%20editorial%20photography%2C%20high%20detail&width=400&height=400&seq=collection-archive-05&orientation=squarish",
  },
  {
    index: "Ⅱ",
    name: "关系图谱与时间线",
    count: "11 篇",
    desc: "谁与谁在什么时间点同行、同场、同框。",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20editorial%20photograph%20of%20a%20timeline%20pinned%20with%20index%20cards%20on%20a%20cream%20wall%2C%20red%20thread%20connecting%20them%2C%20soft%20daylight%2C%20clean%20composition%2C%20professional%20editorial%20photography%2C%20high%20detail&width=400&height=400&seq=collection-timeline-06&orientation=squarish",
  },
  {
    index: "Ⅲ",
    name: "署名与版权合集",
    count: "15 篇",
    desc: "排序、版本号与上架时间戳的对照笔记。",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20editorial%20photograph%20of%20a%20vinyl%20record%20and%20sleeve%20on%20a%20warm%20wooden%20surface%2C%20amber%20tones%2C%20clean%20minimal%20styling%2C%20professional%20editorial%20photography%2C%20high%20detail&width=400&height=400&seq=collection-vinyl-07&orientation=squarish",
  },
  {
    index: "Ⅳ",
    name: "品牌与代言排期",
    count: "7 篇",
    desc: "物料上线、下架与排他条款的逐月记录。",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20editorial%20photograph%20of%20an%20empty%20fashion%20brand%20poster%20frame%20in%20a%20bright%20showroom%2C%20warm%20cream%20walls%20and%20soft%20daylight%2C%20single%20red%20accent%2C%20clean%20composition%2C%20professional%20editorial%20photography%2C%20high%20detail&width=400&height=400&seq=collection-poster-08&orientation=squarish",
  },
  {
    index: "Ⅴ",
    name: "各方回应留档",
    count: "9 篇",
    desc: "声明、经纪人回复与后援会公告的原文照录。",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20an%20empty%20theatre%20stage%20seen%20from%20the%20wings%20with%20warm%20spotlights%2C%20deep%20shadows%20and%20cream%20floor%2C%20minimal%20dramatic%20composition%2C%20professional%20editorial%20photography%2C%20high%20detail&width=400&height=400&seq=collection-stage-09&orientation=squarish",
  },
];

export const archiveLead = {
  tag: "线索档案",
  title: "通告单上的空白格：三次补拍为何都跳过同一天",
  excerpt:
    "把三份补拍通告并排铺开，会发现同一个日期段在每一份里都被留空。单独看像是巧合，叠在一起就更像是一次被默认遵守的默契。",
  meta: "整理于 2026.09.08 · 深扒组",
  image:
    "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20film%20production%20call%20sheet%20and%20clapperboard%20lying%20on%20a%20concrete%20floor%2C%20dramatic%20side%20light%2C%20warm%20neutral%20tones%20with%20a%20single%20red%20accent%2C%20minimal%20composition%2C%20professional%20editorial%20photography%2C%20high%20detail&width=900&height=640&seq=archive-lead-call-sheet-10&orientation=landscape",
};

export const archiveSmall = [
  {
    tag: "行程",
    title: "两次机场路透之间，行程表上多出来的一整天空档",
    meta: "5 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20editorial%20photograph%20of%20a%20folded%20newspaper%20and%20a%20coffee%20cup%20on%20a%20bright%20airport%20waiting%20bench%2C%20warm%20cream%20tones%2C%20soft%20light%2C%20clean%20composition%2C%20professional%20editorial%20photography%2C%20high%20detail&width=400&height=300&seq=archive-small-transit-11&orientation=landscape",
  },
  {
    tag: "物料",
    title: "同一组剧照的两个版本：调色之外还改掉了什么",
    meta: "6 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20editorial%20photograph%20of%20stacked%20printed%20film%20stills%20and%20contact%20sheets%20on%20a%20light%20wooden%20table%2C%20soft%20natural%20light%2C%20warm%20cream%20and%20muted%20tones%2C%20clean%20styling%2C%20professional%20editorial%20photography%2C%20high%20detail&width=400&height=300&seq=archive-small-press-12&orientation=landscape",
  },
  {
    tag: "合作",
    title: "新歌上架前一晚，播放平台上的两个作者名被同时改写",
    meta: "7 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20editorial%20photograph%20of%20a%20smartphone%20showing%20a%20music%20playlist%20app%20on%20a%20warm%20cream%20desk%20beside%20headphones%2C%20soft%20daylight%2C%20muted%20tones%2C%20clean%20minimal%20styling%2C%20professional%20editorial%20photography%2C%20high%20detail&width=400&height=300&seq=archive-small-playlist-13&orientation=landscape",
  },
];

export const timelineEvents = [
  {
    date: "2024.03",
    title: "开机通告发布",
    note: "主演名单首次对外出现，排序沿用初版剧本会结论。",
  },
  {
    date: "2024.07",
    title: "招商页更新",
    note: "平台概念海报换人，旧版物料未做下架说明。",
  },
  {
    date: "2024.11",
    title: "补拍通告流出",
    note: "第三集叙事线整体后移，补拍名单与首版不同。",
  },
  {
    date: "2025.02",
    title: "品牌海报下架",
    note: "合作方在季度复核后撤下同款主视觉。",
  },
  {
    date: "2025.06",
    title: "版权清单调整",
    note: "两首合作曲署名顺序对调，版本号随之更新。",
  },
  {
    date: "2026.01",
    title: "三方同场未同框",
    note: "同一活动现场，三组人马全程未出现在同一镜头。",
  },
];

export const reactions = [
  {
    source: "剧组工作人员（匿名）",
    role: "现场",
    quote:
      "补拍那天棚里只留了必要工种，通告上一向写得很含糊。大家心里明白，但没人会去问为什么。",
    highlight: false,
  },
  {
    source: "品牌公关部回函",
    role: "品牌",
    quote:
      "物料调整属于常规季度复盘，与任何个人因素无关。我们不对第三方转述的排期细节做出回应。",
    highlight: true,
  },
  {
    source: "主演后援会公告",
    role: "粉丝",
    quote:
      "请以官方发布为准，抵制任何未经核实的行程与关系推测。相关截图我们已做统一留证。",
    highlight: false,
  },
  {
    source: "行业观察者 麦冬",
    role: "观察",
    quote:
      "一部剧的名单变化从来不是单点事件。通告、物料、版权是三套系统，它们同时调整，才值得记一笔。",
    highlight: false,
  },
  {
    source: "音乐制作人（前合作方）",
    role: "行业",
    quote:
      "署名顺序在合同里是写清楚的。真正会上浮的，往往是合同没写到的那种默契。",
    highlight: false,
  },
];

export const ranking = [
  { rank: "01", title: "《长夜未明》换角前后完整时间线", heat: "9.8 万", trend: "up" },
  { rank: "02", title: "代言排他条款的七个月重叠是怎么来的", heat: "7.4 万", trend: "up" },
  { rank: "03", title: "被剪掉的 23 分钟：六期分镜对照", heat: "6.1 万", trend: "flat" },
  { rank: "04", title: "两首歌三个版本：署名顺序变动记录", heat: "5.3 万", trend: "down" },
  { rank: "05", title: "同场未同框：2026 年首场活动留档", heat: "4.7 万", trend: "up" },
  { rank: "06", title: "后援会历年公告措辞变化对照表", heat: "3.2 万", trend: "flat" },
];

export const topicBars = [
  { label: "换角与排期", value: 82 },
  { label: "署名与版权", value: 64 },
  { label: "品牌与代言", value: 48 },
  { label: "节目剪辑", value: 35 },
];

export const footerColumns = [
  {
    title: "栏目",
    links: [
      { label: "深扒精选", href: "#deep-dive" },
      { label: "合集索引", href: "#collections" },
      { label: "线索档案", href: "#archive" },
      { label: "线索时间线", href: "#timeline" },
    ],
  },
  {
    title: "内容",
    links: [
      { label: "各方回应留档", href: "#reactions" },
      { label: "深扒热度榜", href: "#ranking" },
      { label: "当期订阅", href: "#subscribe" },
      { label: "封面故事", href: "#cover" },
    ],
  },
  {
    title: "关于",
    links: [
      { label: "深扒组说明", href: "#deep-dive" },
      { label: "线索来源规范", href: "#timeline" },
      { label: "更正与申明", href: "#reactions" },
      { label: "加入深扒组", href: "#subscribe" },
    ],
  },
];